import { DefaultView } from './default-view';
import { useListBoxContext } from './list-box-context';
import { PrimaryView } from './primary-view';
import { ListBoxView } from './types.js';

export const ListBoxPopoverContainer = () => {
  const { currentView, defaultViewConfig, primaryViewConfig, onClose, setCurrentView } = useListBoxContext();

  if (currentView === ListBoxView.Primary) {
    return (
      <PrimaryView
        primaryViewConfig={primaryViewConfig}
        onClose={onClose}
        onBack={() => setCurrentView(ListBoxView.Default)}
        onAction={async () => {
          const success = await primaryViewConfig?.onAction();
          if (success) {
            onClose();
          }
        }}
      />
    );
  }

  return (
    <DefaultView
      defaultViewConfig={defaultViewConfig}
      onAction={
        defaultViewConfig?.onAction
          ? async () => {
              await defaultViewConfig?.onAction?.();
              setCurrentView(ListBoxView.Primary);
            }
          : undefined
      }
      onCancel={defaultViewConfig?.onCancel}
    />
  );
};
